import { useSpectral } from "@spectral-finance/spectral-modal";
import React, { useEffect, useState } from "react";
import "./styles.css";

function Score() {
  const { start, score } = useSpectral();
  const [myScore, setMyScore] = useState<number | null>(null);

  useEffect(() => {
    if (!score) {
      console.log("Score not calculated");
      return;
    }
    console.log(`Hooray! your score is ${score}`);
    setMyScore(score);
  }, [score]);

  return (
    <div className="container">
      <div className="calculateBox">
        {!myScore && (
          <>
            <h1>
              <label>Spectral</label> Score
            </h1>
            <button type="button" onClick={start}>
              Calculate
            </button>
          </>
        )}
        {myScore && (
          <>
            <div>
              <h1>
                Your
                <label> Spectral</label> Score is: <br />
                <label className="score">{myScore}</label>
              </h1>
            </div>
            <br />
            <span className="learnMore">
              Learn more on:{" "}
              <a href="https://spectral.finance" target="_blank">
                https://spectral.finance
              </a>
            </span>
          </>
        )}
      </div>
    </div>
  );
}

export default Score;
